const AcademicSchedule = () => {
    return (
        <div id="timing" className="vision-card">

            <h2 className="pta-title">
                ACADEMIC SCHEDULE
            </h2>

            <div className="schedule-wrapper">
                <div className="schedule-header">
                    <h2>NAV JEEVAN MISSION SCHOOL</h2>
                    <h4>Ashish Nagar, Sonughat, Deoria </h4>
                    <br />
                    <h2>TIME TABLE</h2>
                    <h4>w.e.f. 01<sup>st</sup>July 2026</h4>
                </div>

                <table className="modern-schedule-table">
                    <thead>
                        <tr>
                            <th>TIME</th>
                            <th>ACTIVITY</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr className="lunch-row">
                            <td>07:30 AM - 07:40 AM</td>
                            <td>Uniform & Diary Checking </td>
                        </tr>

                        <tr>
                            <td>07:40 AM - 08:00 AM</td>
                            <td>🙏 Assembly </td>
                        </tr>

                        <tr>
                            <td>08:00 AM TO 08:40 AM</td>
                            <td>1<sup>st</sup> Period</td>
                        </tr>

                        <tr>
                            <td>08:40 AM TO 09:20 AM</td>
                            <td>2<sup>nd</sup> Period</td>
                        </tr>

                        <tr>
                            <td>09:20 AM TO 10:00 AM</td>
                            <td>3<sup>rd</sup> Period</td>
                        </tr>

                        <tr>
                            <td>10:00 AM TO 10:40 AM</td>
                            <td>4<sup>th</sup> Period</td>
                        </tr>

                        <tr className="lunch-row">
                            <td>10:40 AM TO 11:00 AM</td>
                            <td>🍴 Lunch Break</td>
                        </tr>

                        <tr>
                            <td>11:00 AM TO 11:35 AM</td>
                            <td>5<sup>th</sup> Period</td>
                        </tr>

                        <tr>
                            <td>11:35 AM TO 12:10 PM</td>
                            <td>6<sup>th</sup> Period</td>
                        </tr>

                        <tr>
                            <td>12:10 PM TO 12:45 PM</td>
                            <td>7<sup>th</sup> Period</td>
                        </tr>

                        <tr>
                            <td>12:45 PM TO 01:25 PM</td>
                            <td>8<sup>th</sup> Period</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default AcademicSchedule;